<template>
  <div>
    <page-header>
      <el-select v-model="filter.category" value-key="id" style="margin-right: 12px">
        <el-option :value="null" label="全部"/>
        <el-option v-for="imageCategory of imageCategoryList" :key="imageCategory.id" :value="imageCategory" :label="imageCategory.name"/>
      </el-select>
      <el-button type="primary" circle icon="el-icon-search" @click="getImageList(1)"/>
      <el-button type="primary" @click="uploadImage" :disabled="!filter.category">上传图片</el-button>
    </page-header>
    <table-union-pager :data="tableData" @current-change="getImageList">
      <el-table-column label="图片">
        <template #default="scope">
          <el-image class="list-image" :src="scope.row.url" :preview-src-list="[scope.row.url]"/>
        </template>
      </el-table-column>
      <el-table-column prop="filename" label="文件名"/>
      <el-table-column prop="alias" label="名称"/>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button icon="el-icon-delete" type="text" @click="deleteImage(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </table-union-pager>
    <image-uploader v-model="uploader.visible" :category="uploader.category" @upload="finishUpload"/>
  </div>
</template>

<script>
import api from "@/utils/api";
import TableUnionPager from "@/components/TableUnionPager";
import PageHeader from "@/components/PageHeader";
import ImageUploader from "@/components/ImageUploader";

export default {
  name: "Images",
  components: {ImageUploader, PageHeader, TableUnionPager},
  data() {
    return {
      tableData: {
        list: [],
        totalCount: 0,
        page: 1,
        pageSize: 10
      },
      imageCategoryList: [],
      filter: {
        all: false,
        category: null
      },
      uploader: {
        visible: false,
        category: null
      }
    }
  },
  methods: {
    getImageList(page) {
      let categoryId;
      if (this.filter.category) {
        categoryId = this.filter.category.id;
      } else {
        categoryId = null;
      }
      api.image_getImageList({
        page: page,
        pageSize: this.tableData.pageSize,
        categoryId: categoryId
      }).then(res => {
        this.tableData.list = res.data.data.list;
        this.tableData.totalCount = res.data.data.totalCount;
      });
    },
    getImageCategoryList() {
      api.image_getImageCategoryList({}).then(res => {
        this.imageCategoryList = res.data.data;
      });
    },
    uploadImage() {
      if (!this.filter.category) {
        this.$message.error('请先选择分类');
        return;
      }
      this.uploader.visible = true;
      this.uploader.category = this.filter.category;
    },
    finishUpload() {
      this.getImageList(this.tableData.page);
    },
    deleteImage(image) {
      this.$confirm('确定删除当前图片吗?').then(confirm => {
        if (confirm !== 'confirm') {
          return;
        }
        api.image_deleteImage({
          id: image.id
        }).then(res => {
          if (res.data.code !== '000') {
            this.$message.error(res.data.message);
            return;
          }
          this.getImageList(this.tableData.page);
        }).catch(e => {
        });
      })
    }
  },
  mounted() {
    this.getImageCategoryList();
    this.getImageList(1);
  }
}
</script>

<style lang="scss" scoped>
.list-image {
  width: 80px;
  height: 80px;
}
</style>
